export const watch = {
  currentOwnerId(ownerID) {
    console.debug(ownerID)
    this.refresh()
  }
}
